import React from 'react';
import { getAggregatedTitleImage } from '../../../queries/ats/common';
import { PlayablePlaybackOption } from '../../../queries/ats/titles/types/playback-option';
import { PlayableTitle } from '../../../queries/ats/titles/types/title';
import { DetailsLink } from '../../../views/ats-details/details-link';
import PlayerAssetCard from '../UI/PlayerAssetCard';

interface PlayerCardProps {
  title: PlayableTitle;
  playbackOption?: PlayablePlaybackOption;
}

export function PlayerCard({ title, playbackOption }: PlayerCardProps) {
  return (
    <DetailsLink
      className="player-asset-card-link"
      id={title.masterId}
      type={title.type}
      params={
        playbackOption !== undefined
          ? {
              platformTitleId: playbackOption.platformTitleId,
              orderByProviderId: playbackOption.providerIdentifier,
              orderByServiceType: playbackOption.serviceType,
            }
          : undefined
      }
    >
      <PlayerAssetCard image={getAggregatedTitleImage(title.masterId, 'wide', 500)} currentTitle={title.titleName} />
    </DetailsLink>
  );
}
